import { ApiClient, IErrorPayload } from '@color/lib';
import { useMutation } from '@tanstack/react-query';

import { IHealthProfileResponse } from 'ui/common/apis/healthHistory/api';

import { CreateHealthHistoryFormikValues } from './types';

const GET_HEALTH_PROFILE_FOR_SUPPORT_TOOL_URL =
  '/api/v1/health_history/get_health_profile_for_support_tool';

export const fetchHealthHistory = async (query: string) => {
  return ApiClient.get(GET_HEALTH_PROFILE_FOR_SUPPORT_TOOL_URL, {
    params: {
      query,
    },
  });
};

const CREATE_HEALTH_PROFILE_FROM_SUPPORT_TOOL_URL =
  '/api/v1/health_history/create_health_profile_from_support_tool';

interface IUseCreateHealthHistoryMutationOptions {
  onError?: (error: IErrorPayload, formValues: CreateHealthHistoryFormikValues) => void;
}

export function useCreateHealthHistoryMutation(options: IUseCreateHealthHistoryMutationOptions) {
  return useMutation<IHealthProfileResponse, IErrorPayload, CreateHealthHistoryFormikValues>({
    mutationFn: async (formValues: CreateHealthHistoryFormikValues) => {
      return ApiClient.post(CREATE_HEALTH_PROFILE_FROM_SUPPORT_TOOL_URL, {
        json: { ...formValues },
      });
    },
    onError: (error: IErrorPayload, formValues: CreateHealthHistoryFormikValues) => {
      options.onError?.(error, formValues);
    },
  });
}
